import React from "react";
import { HighlightBanner } from "@/components/atoms/HighlightBanner";
import { Text } from "@/components/atoms/Text";
import { ButtonBanner } from "@/components/atoms/ButtonBanner";
import { Image } from "@/components/atoms/Image";
import { Timer } from "@/components/atoms/Timer";
import useBreakpoint from "@/hooks/useBreakpoint";
import "./styles.scss";

export const HighlightLeftText = ({
  textHighlight,
  activeGlyph,
  nameGlyph,
  text,
  textAdditional,
}) => {
  return (
    <div className="highlight-left-text">
      <HighlightBanner
        text={textHighlight}
        activeGlyph={activeGlyph}
        nameGlyph={nameGlyph}
      />
      <Text
        text={text}
        textAdditional={textAdditional}
        customClassText={"highlight-left-text__text"}
      />
    </div>
  );
};

export const HighlightLeftTextAdditional = ({
  textHighlight,
  activeGlyph,
  nameGlyph,
  text,
  textAdditional,
}) => {
  return (
    <div className="highlight-left-text-additional">
      <div className="highlight-left-text-additional__highlight">
        <HighlightBanner
          text={textHighlight}
          activeGlyph={activeGlyph}
          nameGlyph={nameGlyph}
        />
      </div>
      <Text text={text} textAdditional={textAdditional} />
    </div>
  );
};

export const TextHighlightRightGoButton = ({
  textHighlight,
  text,
  activeBtnGo,
}) => {
  return (
    <div className="text-highlight-right-go-button">
      <Text
        text={text}
        customClassText="text-highlight-right-go-button__text"
      />
      <HighlightBanner text={textHighlight} />
      <ButtonBanner activeBtnGo={activeBtnGo} />
    </div>
  );
};

export const ImageText = ({
  text,
  imagePng,
  imageWebp,
  isDefaultImg  = false,
  defaultClass = 'default-icon-large',
}) => {
  const isDesktop = useBreakpoint("large-min");
  const pngSrc = isDesktop
    ? imagePng?.image_desktop?.url || ""
    : imagePng?.image_mobile?.url || "";
  const webpSrc = isDesktop
    ? imageWebp?.image_desktop?.url || ""
    : imageWebp?.image_mobile?.url || "";

  return (
    <div className="image-text">
      <div className={`image-text__image ${isDefaultImg  ? defaultClass : ''}`}>
        <Image
          pngSrc={pngSrc}
          webpSrc={webpSrc}
          alt="Image"
          className={`!relative ${isDefaultImg  ? defaultClass : ''}`}
        />
      </div>
      <Text text={text} />
    </div>
  );
};

export const ImageTextTimer = ({
  text,
  imagePng,
  imageWebp,
  activeCounter,
  startDate,
  finalDate,
  resetDays,
  isDefaultImg  = false,
  defaultClass = 'default-icon-large',
}) => {
  const isDesktop = useBreakpoint("large-min");
  const pngSrc = isDesktop
    ? imagePng?.image_desktop?.url || ""
    : imagePng?.image_mobile?.url || "";
  const webpSrc = isDesktop
    ? imageWebp?.image_desktop?.url || ""
    : imageWebp?.image_mobile?.url || "";

  return (
    <div className="image-text-timer">
      <div
        className={`image-text-timer__image ${isDefaultImg ? defaultClass : ''}`}
      >
        <Image
          pngSrc={pngSrc}
          webpSrc={webpSrc}
          alt="Image"
          className={`!relative ${isDefaultImg ? defaultClass : ''}`}
        />
      </div>

      <div className="image-text-timer__information">
        <Text
          text={text}
          customClassText="image-text-timer__information--text"
        />
        {activeCounter && (
          <Timer
            startDate={startDate}
            finalDate={finalDate}
            resetDays={resetDays}
          />
        )}
      </div>
    </div>
  );
};

export const HighlightLeftTextWithButton = ({
  textHighlight,
  text,
  activeBtnClose,
  activeBtnGo,
  customClassBtnGo,
  customClassText,
}) => {
  return (
    <div className="highlight-left-text-with-button">
      <HighlightBanner text={textHighlight} />
      <Text text={text} customClassText={customClassText} />
      <ButtonBanner
        activeBtnClose={activeBtnClose}
        activeBtnGo={activeBtnGo}
        customClassBtnGo={customClassBtnGo}
      />
    </div>
  );
};
